export default __webpack_public_path__ + "static/h12-d7f18211538c65debba695a88f620bf9.png";